var map = {
	"./ic_bal_40.svg": 445,
	"./ic_btc_40.svg": 446,
	"./ic_crv_40.svg": 447,
	"./ic_dai_40.svg": 448,
	"./ic_eth_40.svg": 329,
	"./ic_frax_40.svg": 449,
	"./ic_fxs_40.svg": 450,
	"./ic_link_40.svg": 451,
	"./ic_mim_40.svg": 452,
	"./ic_mlp_40.svg": 147,
	"./ic_myc_40.svg": 267,
	"./ic_ppusd_40.svg": 453,
	"./ic_tcr_40.svg": 454,
	"./ic_test_40.svg": 455,
	"./ic_uni_40.svg": 456,
	"./ic_usdc.e_40.svg": 457,
	"./ic_usdc_40.svg": 458,
	"./ic_usdt_40.svg": 459,
	"./ic_weth_40.svg": 460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 328;